import React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { FlowEditor, FlowEditorHandle } from './FlowEditor';
import { FlowDefinitionDto, EditorLookups, DotNetRef, FlowNodeDto, FlowEdgeDto } from './types';
import './styles.css';

interface MountedInstance {
  loadDefinition(def: FlowDefinitionDto): void;
  extractDefinition(): { nodes: FlowNodeDto[]; edges: FlowEdgeDto[] };
  dispose(): void;
}

interface MountArgs {
  containerId: string;
  initialDefinition: FlowDefinitionDto | null;
  lookups: EditorLookups;
  dotNetRef: DotNetRef;
}

function mount(args: MountArgs): MountedInstance {
  const container = document.getElementById(args.containerId);
  if (!container) {
    throw new Error(`[flow-editor] container "${args.containerId}" not found`);
  }
  const handleRef: { current: FlowEditorHandle | null } = { current: null };
  const root: Root = createRoot(container);

  root.render(
    <React.StrictMode>
      <FlowEditor
        initialDefinition={args.initialDefinition}
        lookups={args.lookups}
        dotNetRef={args.dotNetRef}
        handleRef={handleRef}
      />
    </React.StrictMode>,
  );

  return {
    loadDefinition: (def) => handleRef.current?.loadDefinition(def),
    extractDefinition: () => handleRef.current?.extractDefinition() ?? { nodes: [], edges: [] },
    dispose: () => {
      root.unmount();
    },
  };
}

// Expose to Blazor.
(window as unknown as { wisertalk: { flowEditor: { mount: typeof mount } } }).wisertalk =
  (window as unknown as { wisertalk?: { flowEditor?: unknown } }).wisertalk ?? {} as any;
(window as unknown as { wisertalk: { flowEditor: { mount: typeof mount } } }).wisertalk.flowEditor = { mount };

console.log('[wisertalk.flowEditor] ready');
